(() => {
  const initialize = () => {
    document.querySelectorAll('[data-vj-topics]').forEach(details => {
      if (details.dataset.vjReady) return;
      details.dataset.vjReady = 'true';
      details.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          details.open = false;
          details.querySelector('summary').focus();
        }
      });
      details.addEventListener('focusout', event => {
        if (event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false;
      });
    });
    document.querySelectorAll('.vj-article .content-blog table').forEach(table => {
      if (table.parentElement.classList.contains('vj-table-scroll')) return;
      const scroller = document.createElement('div');
      scroller.className = 'vj-table-scroll';
      scroller.tabIndex = 0;
      scroller.setAttribute('role', 'region');
      scroller.setAttribute('aria-label', document.querySelector('.vj-article').dataset.tableLabel);
      table.before(scroller);
      scroller.append(table);
    });
  };
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-vj-topics][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
